import { useContext } from 'react';

// CONTEXT
import { UserDataContext } from 'context/UserDataContext';

// Les données utilisateur sont désormais mutualisées via le UserDataProvider :
// un seul fetch pour toute l'application, au lieu d'un par composant.
// Les éventuels arguments passés (email, isInternal, ...) sont ignorés et conservés
// uniquement pour la compatibilité avec les anciens appels — l'identité provient
// d'AuthContext au niveau du provider.
export default function useUserData() {
    return useContext(UserDataContext);
}
